import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';
import { imageUrl } from '../Shared/imageUrl';

export const SplitContent = createComponent('div', {
  className: 'grid grid-rows-[1fr_auto] sm:grid-cols-2 sm:grid-rows-1'
});

export const LeftImage = createComponent('div', {
  className: cx(
    'h-[100vw] sm:h-auto',
    'bg-[length:100%_100%] bg-no-repeat',
    '[background-image:var(--mobile-image)] sm:[background-image:var(--tablet-image)] md:[background-image:var(--desktop-image)]'
  ),
  style: {
    '--mobile-image': `url(${imageUrl('vm-2-hero.jpg', {
      format: 'auto',
      optimize: 'medium'
    })})`,
    '--tablet-image': `url(${imageUrl('vm-2-hero.jpg', {
      format: 'auto',
      optimize: 'medium'
    })})`,
    '--desktop-image': `url(${imageUrl('vm-2-hero.jpg', {
      format: 'auto',
      optimize: 'medium'
    })})`
  }
});
